module.exports = __webpack_public_path__ + "img/mdi_twitter.4842aefc.png";